import { initSentry } from "@/lib/sentry";

initSentry();
